module.exports = __webpack_public_path__ + "img/13.db390c0c.jpg";